export const OPEN_POSITIONS_URL = 'https://dev.bg/company/hacksoft/#jobs';
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
export const DATO_TYPE_IDS = {
  CONTENT_PAGE: '6OYb9lgvRfmHCRFY7h6_kw',
  NAVIGATION_PAGE: 'dvUs5Q17QVetiZn6I9DFUg'
};
